import React from "react"

function Balance({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M18 8V27.5" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M11.5 27.5H24.5" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M11.5 10H24.5" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M11.5 10L8.5 18" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M11.5 10L15 18" stroke="#003E4C" strokeWidth="0.75" />
      <path
        d="M8.5 18C8.5 18 8.5 21.5 11.75 21.5C15 21.5 15 18 15 18H8.5Z"
        stroke="#003E4C"
        strokeWidth="0.75"
      />
      <path d="M24.5 10L21 18" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M24.5 10L27.5 18" stroke="#003E4C" strokeWidth="0.75" />
      <path
        d="M21 18C21 18 21 21.5 24.25 21.5C27.5 21.5 27.5 18 27.5 18H21Z"
        stroke="#003E4C"
        strokeWidth="0.75"
      />
    </svg>
  )
}
export default Balance
